export default __webpack_public_path__ + "assets/1d2138d355b305d39c599e916a88e5e6.svg";